<template>
  <div class="alert-wrapper">
    <v-alert
      v-if="activeSubscription && subscriptionAccessType === 'LIMITED'"
      density="compact"
      class="alert"
    >
      <div class="d-flex align-center ga-2">
        <v-icon size="large">$warning</v-icon>
        <span v-if="activeSubscription?.lastSubscriptionDetails?.clientSecret">
          Your current subscription is past due because your latest payment requires authentication.
          To continue using Qlerify with full access, please
          <RouterLink to="/subscription/my-plan">
            authenticate the payment.
          </RouterLink>
        </span>
        <span v-else class="d-flex ga-1">
          You currently don't have an active subscription. To continue using Qlerify with full access, please consider
          <RouterLink to="/subscription/my-plan" v-if="isSubscriptionAdmin">upgrading your plan.</RouterLink>
          <RouterLink v-else to="/plans">selecting your plan.</RouterLink>
        </span>
      </div>
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      userId: state => state.userId,
      currentUser: state => state.user.user,
      activeSubscription: (state) => state.payments.activeSubscription,
      subscriptionAccessType: (state) => state.payments.subscriptionAccessType,
      isSubscriptionAdmin: state => state.payments.isSubscriptionAdmin
    }),
    nextBillingDate () {
      const nextBillingDate = this.activeSubscription?.subscriptionDetails?.nextBillingDate
      if (nextBillingDate) {
        return new Date(nextBillingDate)
      }
      return null
    }
  }
}
</script>

<style scoped>
.alert-wrapper {
  width: 100vw;
  margin-left: -40px;
}

.alert {
  font-size: 14px;
  border-radius: 0;
  background-color: #73E5A6;
}
</style>
